import React from 'react';



const FilterCategories = props => <div className={props.className}>CategoriesFilter</div>;
export default FilterCategories;
